import { observer } from "mobx-react";
import * as React from "react";
import styles from "./style.module.sass"
import { MenuItem, MenuType } from "../../services/menu/models";
import { useStores } from "../../hooks";
import useOpenMenuItem from "../../hooks/useOpenMenuItem";
import { MinusButton, PlusButton } from "../buttons/plusButton";
import { ChosenMenuItemModifierSet } from "../../types/types";


interface IProps {
    menuItem: MenuItem,
    index: number,
    size?: "small" | "default",
    menuItemsCount?: number,
    indexToRemove?: number,
    onCartPage: boolean,
    chosenMenuItemModifierSets?: ChosenMenuItemModifierSet[]
}

const PlusMinusWidget = (props: IProps) => {
    const { cartStore, generalMenuStore } = useStores();
    const { openMenuItem } = useOpenMenuItem();
    const currentMenu = generalMenuStore.menu;

    let count = props.menuItemsCount;

    if (!currentMenu) return null;

    if (!count && currentMenu) {
        const cartItem = cartStore.getCartItemById(props.menuItem.id);
        if (!cartItem) return null;
        count = cartItem.count;
    }


    const size = props.size || 'default';
    const counterClasses = [styles.counter];
    if (size === 'small') {
        counterClasses.push(styles.small)
    }

    return <div className={styles.plusMinusWidget}>
        <MinusButton
            size={props.size}
            onClick={(e: React.MouseEvent) => {
                e.stopPropagation()
                cartStore.removeItem(props.menuItem.id, {
                    indexToRemove: props.indexToRemove !== undefined ? props.indexToRemove : -1,
                    all: false
                });
            }}/>
        <span className={counterClasses.join(" ")}>{count}</span>
        <PlusButton size={props.size}
                    onClick={(e: React.MouseEvent) => {
                        e.stopPropagation();
                        if (props.menuItem.data.menuItemModifierSets.length === 0) {
                            if (currentMenu.type === MenuType.regular) {
                                cartStore.addItem(props.menuItem, [], 1);
                            }
                        } else {
                            if (props.onCartPage && currentMenu.type === MenuType.regular) {
                                cartStore.addItem(props.menuItem, props.chosenMenuItemModifierSets || [], 1);
                            } else {
                                openMenuItem(props.menuItem);
                            }
                        }
                    }}/>
    </div>
};


export default observer(PlusMinusWidget)
